import React, { useState } from "react";
import * as Yup from "yup";
import {
  Col,
  Container,
  Row,
  Card,
  Table,
  UncontrolledCollapse,
  CloseButton,
  Input,
  Form,
  Button,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import Papa from "papaparse";
import { Bounce, toast } from "react-toastify";
import endpoints from "../../../api/endpoints";
import { post } from "../../../api/axios";
import { useNavigate } from "react-router-dom";

const AddBulk = () => {
  document.title = " Add Bulk | Elevated Iron - Admin Dashboard";
  const navigate = useNavigate();
  const [file, setFile] = useState();
  const [array, setArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleOnChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

      if (fileType !== "text/csv" && fileExtension !== "csv") {
        toast.error("Only CSV files are allowed!", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
        setFile(null); // Reset file state
        e.target.value = null; // Clear file input
        return;
      }

      setFile(selectedFile);
    }
  };

  const handleOnSubmit = (e) => {
    setShow(true);
    e.preventDefault();

    if (file) {
      Papa.parse(file, {
        complete: function (results) {
          if (results.data.length === 0) {
            toast.error("The CSV file is empty!", {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            });
            return;
          }

          // Define expected headers
          const expectedHeaders = [
            "name",
            "description",
            "specialInfo",
            "gymTag",
            "email",
            "phoneNumber",
            "website",
            "facebook",
            "instagram",
            "googleMap",
          ];

          // Extract actual headers from uploaded CSV
          const actualHeaders = results.meta.fields;
          console.log(actualHeaders, "========");
          if (!actualHeaders) {
            toast.error("Invalid CSV format! Please check the file.", {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            });
            return;
          }

          // Check if headers match exactly
          const isValidHeaders =
            JSON.stringify(expectedHeaders) === JSON.stringify(actualHeaders);

          if (!isValidHeaders) {
            toast.error("CSV headers do not match the required format!", {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            });
            return;
          }

          // Filter out empty rows
          const filteredData = results.data.filter((row) =>
            Object.values(row).some((val) => val.trim() !== "")
          );
          setArray(filteredData);
        },
        header: true,
        skipEmptyLines: true,
      });
    } else {
      toast.error("Please upload a CSV file", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  const gymsHandle = async () => {
    if (array.length === 0) {
      toast.error("Please upload csv file", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await post(`${endpoints.seeder}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response?.data?.success) {
        toast.success("Gyms Added Successfully!", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
        navigate("/list-gyms");
      } else {
        toast.error(response?.data.message, {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };
  const HandleReset = () => {
    setShow(false);
    setFile(null);
    setArray([]); // Also reset array
    document.getElementById("csvFileInput").value = ""; // Clear input field
  };
  const headerKeys = array.length > 0 ? Object.keys(array[0]) : [];
  const downloadCSV = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      "name,description,specialInfo,gymTag,email,phoneNumber,website,facebook,instagram,googleMap\n" +
      `Demo,"Welcome to Gym! Locally owned and operated, our welcoming gym offers you a supportive community to reach your health and wellness goals. Our expert coaches and staff are ready to help you every step of the way, including a free fitness consultation and personalized plan. Plus, get 24/7 access to more than 5,000 locations across the globe, which means we?e never far from your home, work or vacation destination. We?e excited to meet you!","24-Hour Access,24-Hour Security,Convenient Parking",NEWGYM,info@example.com,11111111111,https://anytimefitness.com/,https://www.facebook.com/anytimefitness/,https://www.instagram.com/anytimefitness/,https://www.google.com/maps/place/Shamim+Farmhouse/\n`;

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "sample.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  <button type="button" className="rounded-pill1" onClick={downloadCSV}>
    Download our sample CSV
  </button>;

  return (
    <Container fluid>
      <Card className="rounded-4 p-4">
        <Row className="justify-content-center align-items-start">
          <Col xs={12} md={12} lg={12}>
            <div className="d-flex flex-column justify-content-center align-items-start w-100">
              <div className="d-flex flex-wrap align-items-center justify-content-between text-center mb-3 w-100">
                <h3 className="primary-black ff-sora font-size-20 fw-bold">
                  Add Gyms In Bulk
                </h3>
                <button
                  type="button"
                  className="rounded-pill1"
                  onClick={downloadCSV}
                >
                  Download our sample CSV
                </button>
              </div>
              <Form
                className="d-flex rounded-3 flex-column justify-content-center align-items-center mb-3 p-2 w-100"
                style={{ border: "1px dashed #f5f5f5" }}
              >
                <Input
                  className="form-control ff-sora font-size-16 fw-normal"
                  type={"file"}
                  id={"csvFileInput"}
                  accept={".csv"}
                  onChange={handleOnChange}
                  disabled={array.length > 0}
                />
                <div className="d-flex w-100 justify-content-end mt-1">
                  <Button
                    color="white"
                    className="rounded-pill1 me-2"
                    onClick={(e) => {
                      HandleReset(e);
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                    disabled={array.length > 0}
                    className="rounded-pill"
                    onClick={(e) => {
                      handleOnSubmit(e);
                    }}
                  >
                    IMPORT CSV
                  </Button>
                </div>
              </Form>
              {array.length > 0 && show && (
                <>
                  <div
                    className="table-responsive rounded-3 w-100"
                    style={{ border: "2px solid #f5f5f5" }}
                  >
                    <Table striped className="table-centered table-nowrap">
                      <thead>
                        <tr key={"header"}>
                          {headerKeys.map((key, index) => (
                            <th
                              key={index}
                              className="primary-black fw-bold ff-sora font-size-14 text-capitalize"
                            >
                              {key}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody style={{ minHeight: "550px" }}>
                        {array.map((item, rowIndex) => (
                          <tr key={rowIndex}>
                            {Object.values(item).map((val, colIndex) => (
                              <td
                                key={colIndex}
                                className="primary-black fw-normal ff-sora font-size-14 "
                              >
                                {val.length > 50
                                  ? `${val.substring(0, 50)}...`
                                  : val}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className="d-flex w-100 justify-content-end mt-2">
                    <button
                      type="submit"
                      className="me-2 rounded-pill"
                      onClick={gymsHandle}
                      disabled={loading}
                    >
                      {loading ? (
                        <span className="spinner-border spinner-border-sm"></span>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>
          </Col>
        </Row>
      </Card>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "40px",
          position: "sticky",
          bottom: "0",
        }}
      ></div>
    </Container>
  );
};

export default AddBulk;
